import { Divider, Drawer, Input, Space, Checkbox, Tooltip } from "antd";
import React, { useEffect, useState } from "react";
import EditorPanelHeading from "../../UI/EditorPanelHeading";
import BMInput from "../../comps/BMInput";
import { PicRightOutlined, PicLeftOutlined, PicCenterOutlined } from '@ant-design/icons';
import { getColor, getFontFamily } from "../../../utils/ConvertCSS";
import { useTemplate } from "../../../utils/Template";
import ColourPicker from "../../../globals/styles/ColourPicker";
import FontPicker from "../../../globals/styles/FontPicker";
import LinkUI from "../../UI/LinkUI";
import { useSession } from "../../../utils/Session";
import { PaddingHorizontalIcon, PaddingVerticalIcon } from "../../Icons";
import TextEditor from "../../UI/TextEditor";
import RichTextEditor from "../../UI/RichTextEditor";
import Html from "../../../utils/Html";
import { previewLink, tt_asn_padding_x, tt_asn_padding_y, tt_name_block_warning } from "../../../utils/Utils";
import LinkPicker from "../../../globals/styles/LinkPicker";
import PresetPicker from "../../../globals/styles/PresetPicker";

export default function AboveSearchbarNotice(props) {

    const [template, ] = useTemplate();
    const [session, ] = useSession();
    const { edit = false, close = () => { }, saveItem = () => { }, deleteItem = () => { }, id = 0 } = props;
    const [content, setContent] = useState(props.content);

    const setData = (_data) => {
        setContent({ ...content, "data": _data })
    }

    // Component agnostic
    const {
        name = "",
        container = true,
        data = {},
        date_changed = 0
    } = content;

    // Component specific
    const {
        message = "Above Searchbar Notice",
        font = 0,
        text_preset = 0,
        align = "center",
        padding_x = 5,
        padding_y = 5,
        colour = 0,
        background_colour = 0,
        link = "",
        tab = false,
        link_id = 0,
    } = data;

    const save = () => {
        if(!name){
            let _name = prompt(tt_name_block_warning);
            if(_name){
                close();
                saveItem(id, { ...content, "name" : _name });
            } else {
                return; 
            }
        } else {
            close();
            saveItem(id, { ...content })
        }
    }

    const trash = () => {
        deleteItem(id);
        close();
    }

    useEffect(() => {
        if (session.is_editing !== false) {
            return;
        }
        // Function to replace the content of the existing div with a new paragraph
        const replaceContentOfDiv = () => {
            const divId = 'bm-notification'; // Replace 'existingDiv' with the ID of your target div
            const divElement = document.getElementById(divId);
            if (divElement) {
                // Clear the existing content of the div
                divElement.innerHTML = '';
                const cont = document.createElement('div');
                cont.className = "bm-render no_p_margin " + "bm-txt-" + text_preset + " " + "bm-lnkin-" + link_id;
                cont.style["background-color"] = getColor(background_colour, template, "#eee");
                cont.style.setProperty("display", "block", "important");
                // Create a new paragraph element
                const ele = document.createElement('div');
                if (container) {
                    ele.style.width = "1248px"
                    ele.style.margin = "0 auto";
                } else {
                    ele.style.width = "100%"
                    ele.style.margin = "0 auto";
                }
                ele.innerHTML = message;
                ele.style.textAlign = align;
                // ele.style.color = getColor(colour, template, "#fff");
                // ele.style.fontFamily = `'${getFontFamily(font, template)}'`;
                if (message) {
                    ele.style.padding = padding_y + "px " + padding_x + "px";
                }
                if (link) {
                    cont.style.cursor = "pointer";
                    cont.addEventListener("click", function () {
                        window.open(link, (tab) ? "_blank" : "_self");
                    });
                }
                cont.appendChild(ele)
                // Append the paragraph element to the target div
                divElement.appendChild(cont);
            }
        };
        // Call the function to replace the content when the component mounts
        replaceContentOfDiv();

        return () => {
            let divElement = document.getElementById("bm-notification");
            divElement.innerHTML = '';
        }
    })

    const linkOut = () => {
        if (link) {
            window.open(previewLink(link), (tab) ? "_blank" : "_self");
        }
    }

    const drawRender = () => {
        if (session.is_editing === false) {
            return;
        }
        let _contStyle = {
            backgroundColor: getColor(background_colour, template, "#eee"),
            cursor: (link) ? "pointer" : "inherit",
            margin : "0 auto"
        }
        if (container) {
            _contStyle.width = "1248px"
        } else {
            _contStyle.width = "100%"
        }
        let _messageStyle = {
            textAlign: align,
            // color: getColor(colour, template, "#fff"),
            // fontFamily: `'${getFontFamily(font, template)}'`,
        }
        if(message){
            _messageStyle.padding = padding_y + "px " + padding_x + "px"
        }
        return (<>
            <div onClick={() => linkOut()} style={_contStyle}>
                <div style={_messageStyle}><Html anchor={"no_p_margin bm-lnkin-" + link_id + " bm-txt-" + text_preset} html={message} /></div>
            </div>
        </>)
    }

    const drawForm = () => {
        return (
            <>
                <EditorPanelHeading menus={props.menus} close={close} trash={trash} save={save} content={content} setContent={setContent} date_changed={date_changed} name={name} />
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">MESSAGE</Divider>
                <RichTextEditor container={container} paragraph_preset={text_preset} link_id={link_id}  background_colour_default="#eee" background_colour={background_colour} padding_x={padding_x} padding_y={padding_y}  width={1248} value={message} onChange={(_v) => setData({ ...data, "message": _v })} />
                {/* <Input style={{ "fontSize": "11px" }} onChange={(e) => setData({ ...data, "message": e.target.value })} value={message} placeholder="Message text..." /> */}
                <div className="shim" /> <div className="shim" />
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">PADDING / POSITION</Divider>
                <div className="float-flex">
                    <Space>
                        <BMInput width={35} value={padding_x} onChange={(_v) => setData({ ...data, "padding_x": _v })} number min={0} max={100} prefix={<Tooltip title={tt_asn_padding_y}><PaddingHorizontalIcon style={{"color" : "#888"}} /></Tooltip>} />
                        <BMInput width={35} value={padding_y} onChange={(_v) => setData({ ...data, "padding_y": _v })} number min={0} max={100} prefix={<Tooltip title={tt_asn_padding_x}><PaddingVerticalIcon style={{"color" : "#888"}} /></Tooltip>} />
                    </Space>
                    <Space>
                        <div><PicLeftOutlined onClick={() => setData({ ...data, "align": "left" })} style={{ "color": (align === "left") ? "#1890ff" : "#AAA" }} /></div>
                        <div><PicCenterOutlined onClick={() => setData({ ...data, "align": "center" })} style={{ "color": (align === "center") ? "#1890ff" : "#AAA" }} /></div>
                        <div><PicRightOutlined onClick={() => setData({ ...data, "align": "right" })} style={{ "color": (align === "right") ? "#1890ff" : "#AAA" }} /></div>
                    </Space>
                </div>
                <div className="shim" /> <div className="shim" />
                {/* COLOUR */}
                {/* <Divider orientationMargin={0} orientation="left" plain className="simple-divider">TEXT COLOUR</Divider>
                <ColourPicker allow_gradient allow_none value={colour} onChange={(_v) => setData({ ...data, "colour": _v })} />
                <div className="shim" /> <div className="shim" /> */}
                
                {/* <Divider orientationMargin={0} orientation="left" plain className="simple-divider">FONT</Divider>
                <FontPicker value={font} onChange={(e) => setData({ ...data, "font": e })} />
                <div className="shim" /> <div className="shim" /> */}

                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">TEXT PRESET</Divider>
                <PresetPicker value={text_preset} onChange={(e) => setData({ ...data, "text_preset": e })} />
                <div className="shim" /> <div className="shim" />

                {/* BACKGROUND COLOUR */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">BACKGROUND COLOUR</Divider>
                <ColourPicker allow_none value={background_colour} onChange={(_v) => setData({ ...data, "background_colour": _v })} />
                <div className="shim" /> <div className="shim" />
                {/* LINK */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">LINK</Divider>
                <LinkUI value={link} onChange={(e) => setData({ ...data, "link": e })} />
                {/* LINK TARGET */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">LINK TARGET</Divider>
                <Checkbox checked={tab} onChange={(e) => setData({ ...data, "tab": e.target.checked })} ><small>Open in new tab?</small></Checkbox>
                <div className="shim" /> <div className="shim" />

                {/* LINK STYLE */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">LINK STYLE</Divider>
                <LinkPicker value={link_id} onChange={(e) => setData({ ...data, "link_id": e })} />
                <div className="shim" /> <div className="shim" />
            </>
        )
    }

    return (
        <>
            <Drawer bodyStyle={{ "backgroundColor": "#f5f5f5", "overflowX" : "hidden" }} closable={false} width={300} onClose={() => close()} open={edit}>
                {drawForm()}
            </Drawer>
            {drawRender()}
        </>
    )

}